const image = 'https://drive.google.com/uc?id=17MwqimiNTIWsQH5GBsbJYmKAw3jWbpUc';

export {
    image,
};